// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root {\n  /* Colors */\n  --carousel-color-primary: #642afb;\n  --carousel-color-secondary: #8e98f3;\n  --carousel-color-white: #ffffff;\n  /* Navigation */\n  --carousel-nav-width: 30px;\n}", ""]);
// Exports
module.exports = exports;
